import { ReduxUtils } from 'modules/expenses/dependencies';
import { types } from 'modules/expenses/services/actions';

const actionTypes = {
    REQUEST: types.UPDATE_EXPENSE_REQUEST,
    SUCCESS: types.UPDATE_EXPENSE_SUCCESS,
    FAILURE: types.UPDATE_EXPENSE_FAILURE,
    CANCEL: types.UPDATE_EXPENSE_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
